// api/businessInfoAPI.js
import axios from "axios";


import { API_BASE_URL } from '../../config/apiConfig';

// Workflow Levels Operations
// -------------------------

export const getAllWorkFlowLevels = async () => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllWorkFlowLevels`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// User Roles Operations
// --------------------

export const getAllUserRoles = async () => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllUserRoles`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Master Operations
// ----------------

export const getAllMasterOperations = async () => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllMasterOperations`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Workflow Master Operations
// -------------------------

export const getWorkFlowMasterOperations = async () => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetWorkFlowMasterOperations`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Save Operations
// --------------

export const saveApprovalHierarchy = async (hierarchyData) => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveApprovalHierarchy`,
            hierarchyData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const saveRoleOperations = async (operationsData) => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveRoleOperaions`,
            operationsData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Additional CRUD Operations for Future Use
// -----------------------------------------

export const createUser = async (userData) => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/CreateUser`,
            userData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const updateUser = async (userId, userData) => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.put(
            `${API_BASE_URL}/Accounts/UpdateUser`,
            { userId, ...userData },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
         // DEBUG
         // DEBUG

        const response = await axios.delete(
            `${API_BASE_URL}/Accounts/DeleteUser/${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Role Management Operations
// -------------------------

export const createRole = async (roleData) => {
    try {
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/CreateRole`,
            roleData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const updateRole = async (roleId, roleData) => {
    try {
         // DEBUG

        const response = await axios.put(
            `${API_BASE_URL}/Accounts/UpdateRole`,
            { roleId, ...roleData },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const assignUserRole = async (userId, roleId) => {
    try {
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/AssignUserRole`,
            { userId, roleId },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Firm Information Operations
// --------------------------

export const getFirmInfo = async () => {
    try {
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetFirmInfo`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const saveFirmInfo = async (firmData) => {
    try {
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveFirmInfo`,
            firmData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};